import React from "react";

const ASPLocation = (props) => {
    return (
        <tr>
            <td>{props.location.Country}</td>
            <td>
                <div>{props.location.CompanyName}</div>
                <div dangerouslySetInnerHTML={{ __html: props.location.Address }}></div>
                <div>{props.location.TownCity}</div>
                <div>{props.location.AddressCountry}</div>
            </td>
            <td>
                <div>{props.location.ContactName}</div>
                <div>{props.location.EmailAddress}</div>
                <div>{props.location.Telephone}</div>
            </td>
        </tr>
    )
}

export default ASPLocation;